module.exports = "/_next/static/images/do-4ba64fb6d96b7b61fc485af337d348fd.svg";